<template>
  <div class="page-header">
    <div class="header-back-wrap"><slot name="back"></slot></div>
    <div class="handles-wrap">
      <div class="page-header-handle-wrap">
        <div
          v-for="item in NavRouterData"
          :key="item.meta.category"
          class="page-header-handle-item"
          v-if="!item.meta.hidden"
          :class="{
            'active-handle': $route.meta.category == item.meta.category
          }"
          @click="handleTap(item.name)"
        >
          <div class="handle-title">{{ item.meta.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'title'
    },
    NavRouterData: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleTap(name) {
      console.log(name)
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../style/variable.less';

.page-header {
  background-color: @pageHeaderColor;
  height: @pageHeaderHeight;
  border-bottom: 1px solid @lineColor;
  display: flex;
  .title-wrap {
    height: 100%;
    width: 300px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    .title {
      font-size: 16px;
      font-weight: normal;
      line-height: 1;
      color: #000;
    }
  }
  .handles-wrap,
  .header-back-wrap {
    display: flex;
    align-items: center;
    .back {
      width: 80px;
      height: calc(100% - 20px);
      font-size: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-right: 1px solid @lineColor;
    }
  }
}
</style>
